import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import React from 'react';

interface PlacedProps {
  blockPath: string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterPlaces: React.FC<PlacedProps> = ({ blockPath, tComponents, filterEnabled = false }) => (
  <Container gap={0} fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.PlacesTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterPlaces`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <TextInput path={`${blockPath}.places`} label={tComponents('DMFilterSearch.InputLabelPlaces')} />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.placesDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.PlacesDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterPlaces;
